import { diffLines } from "diff";

const splitPartLines = (value) => {
  const lines = String(value || "").split("\n");
  if (lines.at(-1) === "") lines.pop();
  return lines;
};

export const buildPolicyDiff = (before = "", after = "") => {
  let oldLine = 1;
  let newLine = 1;
  const rows = [];

  diffLines(String(before), String(after)).forEach((part) => {
    splitPartLines(part.value).forEach((text) => {
      if (part.added) {
        rows.push({ type: "added", oldLine: null, newLine: newLine++, text });
      } else if (part.removed) {
        rows.push({ type: "removed", oldLine: oldLine++, newLine: null, text });
      } else {
        rows.push({
          type: "unchanged",
          oldLine: oldLine++,
          newLine: newLine++,
          text,
        });
      }
    });
  });

  return rows;
};
